// src/components/private/dashboard/HighgardenDash.js
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ProductOffersLatest from '../highgarden/offers/ProductOffersLatest';
import ProductSavingsChart from '../highgarden/analytics/ProductSavingsChart';
import GroceryOffersLatest from '../highgarden/offers/GroceryOffersLatest';
import StoreSavingsChart from '../highgarden/analytics/StoreSavingsChart';
import { Container, Row, Col, Alert, Button, Spinner } from 'react-bootstrap';

const HighgardenDash = () => {
    const [showFavoritesGuide, setShowFavoritesGuide] = useState(false);
    const [loading, setLoading] = useState(true);
    const userInfo = useSelector(state => state.auth.userInfo);
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    const checkUserStatus = useCallback(async () => {
        try {
            // Check if user has favorite stores
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_API_URL}/highgarden/user/favorite-stores/`,
                {
                    params: { page_size: 1 },
                    headers: { 'Authorization': `Token ${token}` }
                }
            );

            // If user has location but no favorite stores, show guide
            if (userInfo?.has_geo_location && (!response.data.results || response.data.results.length === 0)) {
                setShowFavoritesGuide(true);
            }
        } catch (error) {
            console.error("Error checking user status:", error);
        } finally {
            setLoading(false);
        }
    }, [token, userInfo]);

    useEffect(() => {
        checkUserStatus();
    }, [checkUserStatus]);

    if (loading) {
        return (
            <Container fluid className="text-center py-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </Container>
        );
    }

    return (
        <Container fluid>
            {showFavoritesGuide && (
                <Row className="mb-3">
                    <Col>
                        <Alert variant="info" dismissible onClose={() => setShowFavoritesGuide(false)}>
                            <Alert.Heading>🎯 Get Personalized Offers!</Alert.Heading>
                            <p>
                                Great! You've added your location. Now add your favorite stores to see personalized offers and deals nearby.
                            </p>
                            <div className="d-flex gap-2">
                                <Button 
                                    variant="primary" 
                                    size="sm"
                                    onClick={() => navigate('/highgarden/favorites')}
                                >
                                    <i className="bi bi-star"></i> Add Favorite Stores
                                </Button>
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm"
                                    onClick={() => setShowFavoritesGuide(false)}
                                >
                                    Maybe Later
                                </Button>
                            </div>
                        </Alert>
                    </Col>
                </Row>
            )}
            <Row>
                <Col md={6}>
                    <StoreSavingsChart />
                </Col>
                <Col md={6}>
                    <ProductSavingsChart />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md={6}>
                    <GroceryOffersLatest />
                </Col>
                <Col md={6}>
                    <ProductOffersLatest />
                </Col>
            </Row>
        </Container>
    );
};

export default HighgardenDash;
